export const screenReaderInstructions = {
  draggable: `
    To pick up a draggable item, press enter or space.
    Use the arrow keys to move the item.
    Press enter or space again to drop the item in its new position, or press escape to cancel.
  `,
};

// we could memoize this. . .
const cachedContent: { [id: string]: string } = {};

export function getCachedContent(id): string | typeof cachedContent {
  return id ? cachedContent[id] : cachedContent;
}

export const getElementContent = (
  id,
  element: HTMLElement | undefined = undefined
) => {
  const item = (element || document).querySelector(id) as HTMLElement;

  if (!item) {
    return '';
  }

  if (cachedContent[id]) {
    return cachedContent[id];
  }

  const text = (item.querySelector('.chameleon-text') as HTMLElement)
    ?.innerText;

  const imgDescription = item.querySelector('img')?.getAttribute('alt');

  cachedContent[id] = text || imgDescription || '';
  return cachedContent[id];
};

export const announcements = {
  onDragStart({ active }) {
    const draggableContent = getElementContent(`#match-drag-${active.id}`);

    return `Picked up draggable item ${draggableContent}`;
  },

  onDragOver({ active, over }) {
    const draggableContent = getElementContent(`#match-drag-${active.id}`);

    if (over) {
      const droppableContent = getElementContent(`#match-drop-${over.id}`);

      return `Draggable item ${draggableContent} was moved over droppable area ${droppableContent}.`;
    }

    return `Draggable item ${draggableContent} is no longer over a droppable area.`;
  },

  onDragEnd({ active, over }) {
    const draggableContent = getElementContent(`#match-drag-${active.id}`);

    if (over) {
      const droppableContent = getElementContent(`#match-drop-${over.id}`);

      return `Draggable item ${draggableContent} was dropped over droppable area ${droppableContent}`;
    }

    return `Draggable item ${draggableContent} was dropped.`;
  },
  onDragCancel({ active }) {
    const draggableContent = getElementContent(`#match-drag-${active.id}`);

    return `Dragging was cancelled. Draggable item ${draggableContent} was dropped back to its original position.`;
  },
};
